export function convertRequirementsNumbers(requirements: any[]): any[] {
  return requirements.map(req => ({
    ...req,
    contents: req.contents.map((c: any) => ({
      ...c,
      quantity: Number(c.quantity),
      price_unit: Number(c.price_unit),
      tax_rate: Number(c.tax_rate),
      ...(c.rebate_value !== undefined && { rebate_value: Number(c.rebate_value) }),
      ...(c.rebate_quantity !== undefined && { rebate_quantity: Number(c.rebate_quantity) }),
      ...(c.rebate_amount !== undefined && { rebate_amount: Number(c.rebate_amount) }),
    }))
  }))
}
